// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from './icon.style';
interface IProps {
  style?: React.CSSProperties;
}
export const BookIcon: React.FC<IProps> = (props) =><svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{...iconStyle, ...props.style}}>
  <path d="M22.31,1.56c-.44-.38-1.02-.55-1.59-.47-3.78.53-7.27,3.27-8.72,4.55C10.55,4.36,7.06,1.63,3.28,1.09c-.57-.08-1.15.09-1.59.47-.44.38-.69.94-.69,1.52v13.5c0,1.29.97,2.35,2.26,2.48,4.78.48,7.98,3.59,8.04,3.64.19.19.45.29.71.29s.51-.1.71-.29c.03-.03,3.24-3.16,8.04-3.65,1.29-.13,2.26-1.2,2.26-2.48V3.08c0-.58-.25-1.14-.69-1.52ZM3,16.58V3.07c3.56.5,7.01,3.45,8,4.36v12.49c-1.59-1.1-4.2-2.51-7.54-2.85-.26-.03-.46-.24-.46-.49ZM21,16.58c0,.25-.2.47-.46.49-3.34.34-5.95,1.75-7.54,2.85V7.43c.99-.91,4.44-3.86,8-4.35v13.5Z"/>
</svg>


// WEBPACK FOOTER //
// ./src/icons/Book.tsx